module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("First Mariner Books edition 2002")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2001 by James Carroll")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL RIGHTS RESERVED")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Carroll, James, date."), _c('br'), _vm._v("\nConstantine’s sword : the church and the Jews : a history / James Carroll."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v("\nIncludes bibliographical references and index."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 0–395–77927–8 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 0–618–21908–0 (pbk.)"), _c('br'), _vm._v("\n1. Christianity and antisemitism—History. 2. Catholic Church—Relations—Judaism. 3. Judaism—Relations—Catholic Church. I. Title."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BM")]), _vm._v("535."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C")]), _vm._v("37 2001"), _c('br'), _vm._v("\n26l.0'6'09—dc21 00–061329")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("e"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-34888-9"), _c('br'), _vm._v("\nv5.0719")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Portions of this book appeared, in different form, in "), _c('em', [_vm._v("The New Yorker")]), _vm._v(" and "), _c('em', [_vm._v("The Atlantic Monthly.")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Grateful acknowledgment is made to the following authors and publishers for kind permission to reproduce material in this book: "), _c('em', [_vm._v("The Confessions")]), _vm._v(" by Saint Augustine. Translated by R. S. Pine-Coffin. Copyright © 1961 by R. S. Pine-Coffin. Reprinted by permission of Penguin Books Ltd. "), _c('em', [_vm._v("The City of God")]), _vm._v(" by Saint Augustine. Translated by Henry Bettenson. Copyright © 1972 by Henry Bettenson. Reprinted by permission of Penguin Books Ltd. "), _c('em', [_vm._v("Heavenly Powers")]), _vm._v(" by Neil Asher Silberman. Copyright © 1998 by Neil Asher Silberman. Reprinted by permission of Grosset and Dunlap (Putnam). "), _c('em', [_vm._v("Inquisition and Society in Spain")]), _vm._v(" by Henry Kamen. Reprinted by permission of Weidenfeld & Nicolson. "), _c('em', [_vm._v("Marpingen")]), _vm._v(" by David Blackbourn. Reprinted by permission of the author. "), _c('em', [_vm._v("Toward a New Council of Florence")]), _vm._v(" by Nicolaus of Cusa. Translated by William F. Wertz, Jr. Reprinted by permission of the Schiller Institute, Inc. "), _c('em', [_vm._v("Helena Augusta")]), _vm._v(" by Jan Willem Drijvers. Reprinted with the kind permission of © Koninklijke Brill N.V., Leiden. The Netherlands. "), _c('em', [_vm._v("The Jews and the Crusades")]), _vm._v(" by Shlomo Eidelberg. Reprinted by permission of the author and the University of Wisconsin Press. "), _c('em', [_vm._v("Ideology and Experience")]), _vm._v(" by Stephen Wilson. Reprinted by permission of the Littman Library of Jewish Civilization, Oxford, U.K. "), _c('em', [_vm._v("A Social and Religious History of the Jews")]), _vm._v(" by Salo Wittmayer Baron. Copyright © 1969 Columbia University Press. Reprinted by permission of the publisher. "), _c('em', [_vm._v("European Jewry and the First Crusade")]), _vm._v(" by Robert Chazen. Copyright © 1987 The Regents of the University of California. Reprinted by permission of the publisher. "), _c('em', [_vm._v("Dreyfus: A Family Affair")]), _vm._v(" by Michael Bums. Reprinted by permission of the author. "), _c('em', [_vm._v("Héloïse and Abelard")]), _vm._v(" by Étienne Gilson. Copyright 1950, © 1978 by the Pontifical Institute of Mediaeval Studies, Toronto. Reprinted by permission of the copyright owner. "), _c('em', [_vm._v("Vatican Diplomacy and the Jews During the Holocaust, 1939–1943")]), _vm._v(" by John F. Morley. Reprinted by permission of Ktav Publishing House, Inc.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1152e084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0